import CloudinaryMediaView from '@utmb/types/view/CloudinaryMediaView';
import { Image } from '@utmb/design-system/image/Image';
import React from 'react';

import styles from './caroussel.module.scss';

interface ThumbProps {
    selected: boolean;
    onClick: any;
    img: CloudinaryMediaView;
}

const Thumb = (props: ThumbProps) => {
    const { img, selected, onClick } = props;

    return (
        <div className={[styles.embla__slide, styles.embla__slide_thumb, selected ? styles.is_selected : ''].join(' ')}>
            <button onClick={onClick} className={[styles.embla__slide__inner, styles.embla__slide__inner_thumb].join(' ')} type="button">
                <Image image={img} alt={img.alt} objectPosition="fill" className={styles.embla__slide__thumbnail} objectFit="cover" />
            </button>
        </div>
    );
};

export default Thumb;
